<template>
  <main role="main">
    <public-banner class="banner" />
    <notfound />
  </main>
</template>

<script>
import { publicBanner, notfound } from '@/components/layout';
import getBrandConfig from '@/lib/utils/get_brand_config';

const brandConfig = getBrandConfig();

export default {
  route: {
    path: '*',
    priority: -1,
  },
  head() {
    const title = this.$t('Page not found (404)');
    return {
      title: `${title} | ${brandConfig.fullName}`,
    };
  },
  components: {
    publicBanner,
    notfound,
  },
};
</script>

<style lang="scss" scoped>


  .banner {
    border-bottom: 1px solid $pearl-300;
  }
</style>
